import React from 'react';
import {format, fromUnixTime} from 'date-fns';
import {useFirebaseAuthUserStore} from '../../stores/FirebaseAuthUserStore';
import {useFirestoreUserStore} from '../../stores/FirestoreUserStore';

const style = {
	container: `flex flex-col gap-y-4   p-4`,
	header: `flex justify-center   p-4   font-bold text-3xl recommended:text-4xl`,
	list: `flex flex-col gap-y-4`,
	listItem: `flex flex-row gap-x-4`,
	key: `flex basis-1/4 justify-end items-center   text-lg`,
	val: `flex basis-3/4   p-4   text-whirlwindLightest text-lg   bg-whirlwindDarkest   rounded-md   opacity-90`,
};

export const AccountInfo = () => {
	// Zustand
	const firebaseAuthUser = useFirebaseAuthUserStore(
		(state) => state.firebaseAuthUser,
	);
	const firestoreUser = useFirestoreUserStore((state) => state.firestoreUser);

	// Variables
	const info = [
		{
			id: 'email',
			text: 'Account email',
			val: firebaseAuthUser?.email,
		},
		{
			id: 'lastSignInTime',
			text: 'Last signin date',
			val: firebaseAuthUser?.metadata.lastSignInTime,
		},
		{
			id: 'siteVisitCount',
			text: 'Site visit count',
			val: firestoreUser?.site_visit_count,
		},
		{
			id: 'postCount',
			text: 'Post count',
			val: firestoreUser?.post_count,
		},
		{
			id: 'lastPostTime',
			text: 'Last post date',
			val: firestoreUser?.last_posted_at
				? format(
						fromUnixTime(firestoreUser?.last_posted_at.seconds),
						'MMM d yyyy, hh:mm a',
					)
				: 'Never',
		},
		{
			id: 'creationTime',
			text: 'Account creation date',
			val: firestoreUser?.created_at
				? format(
						fromUnixTime(firestoreUser?.created_at.seconds),
						'MMM d yyyy, hh:mm a',
					)
				: 'Never :P',
		},
	];

	return (
		<div className={style.container}>
			<span className={style.header}>Only you can see this info.</span>
			<ul className={style.list}>
				{info.map((display) => (
					<li
						data-test-id={`${display.id}_TEST`}
						key={display.id}
						className={style.listItem}>
						<span className={style.key}>{display.text}</span>
						<span className={style.val}>{display.val}</span>
					</li>
				))}
			</ul>
		</div>
	);
};
